// extracted by mini-css-extract-plugin
module.exports = {"reviews":"Reviews_reviews__3Pb8P","title":"Reviews_title__15FBm","description":"Reviews_description__2dzR2"};